/* eslint-disable react/self-closing-comp */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useLocation } from 'react-router';

import { useAuth } from '../../hooks/auth';

const RemoteAcess: React.FC = () => {
  const { signInToken } = useAuth();
  const location = useLocation();

  const handleLoginToken = React.useCallback(() => {
    try {
      const params: any = new URLSearchParams(location?.search);
      const result: any = {};
      for (const [key, value] of params.entries()) {
        result[key] = value;
      }
      signInToken(result);
      console.log(result);

      console.log(location?.search);
    } catch (e: any) {
      console.log(e);
    }
  }, []);

  React.useEffect(() => {
    const params: any = new URLSearchParams(location?.search);
    const result: any = {};
    for (const [key, value] of params.entries()) {
      result[key] = value;
    }
    signInToken(result);
    console.log(result);

    console.log(location?.search);
  }, [location]);
  return null;
};

export default RemoteAcess;
